/**
 * 实现 Less 的 fade 函数
 * @param {string} color - 颜色值（支持 HEX/RGB/颜色关键字）
 * @param {number} amount - 透明度百分比 (0-100)
 * @returns {string} - 返回 RGBA 格式的颜色值
 */
export const fade = (color: string, amount: number): string => {
  // 颜色解析逻辑
  const parseColor = (input: string) => {
    let r = 0; let g = 0; let b = 0;
    if (input.startsWith('#')) { // 处理 HEX 格式（如 #ff0000）
      const hex = input.slice(1).padEnd(6, '0');
      r = parseInt(hex.slice(0, 2), 16);
      g = parseInt(hex.slice(2, 4), 16);
      b = parseInt(hex.slice(4, 6), 16);
    } else if (input.startsWith('rgb')) { // 处理 RGB 格式（如 rgb(255,0,0)）
      const match = input.match(/(\d+),\s*(\d+),\s*(\d+)/);
      if (match) [r, g, b] = match.slice(1, 4).map(Number);
    }
    return { r, g, b };
  };

  // 计算新透明度 (0-1 范围)
  const alpha = Math.max(0, Math.min(1, amount / 100));
  const { r, g, b } = parseColor(color);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
